import React from "react"
import Form from "./Form.js"
import {usePartOrderData} from "../../hooks/usePartOrderData";
import {useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useDefaultsData} from "../../hooks/useDefaultsData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";



export default function PartOrderForm(props){
    let dataFresh = useSelector(getDataFresh);
    let partOrderLoaded = usePartOrderData(props.match.params.partorder, dataFresh);
    let departmentsLoaded = useDepartmentsData({}, dataFresh);
    let appDefaultsLoaded = useDefaultsData({});
    let trackingOptionsLoaded = useTrackingOptionsData({}, dataFresh);
    return (
        <Form
            loaded={partOrderLoaded && departmentsLoaded && appDefaultsLoaded && trackingOptionsLoaded}
            endpoint={props.endpoint}
            history={props.history}
        />
    )
}